import { LinkButton } from '@frontend/web-react';
import { useAnalytics, useAuthentication } from '@frontend/web/hooks';

// These are route-based names for analytics (not OnboardingPageWrapper step IDs)
type OnboardingLogoutButtonProps = {
  readonly step: 'complete' | 'membership' | 'profile';
};

export const OnboardingLogoutButton = ({ step }: OnboardingLogoutButtonProps) => {
  const { logout } = useAuthentication();
  const { track } = useAnalytics();

  const handleLogout = () => {
    track({
      data: { step },
      event: 'onboardingLogout',
      topic: 'auth',
    });
    logout();
  };

  return (
    <LinkButton
      color="tertiary"
      label="Logout"
      leftIconName="IconLogout"
      onClick={handleLogout}
      textClassName="font-normal"
    />
  );
};
